import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Fire, CheckCircle } from "@phosphor-icons/react";
import api, { fileUrl } from "../lib/api";

const MEDALS = ["🥇", "🥈", "🥉"];

/** StreakLeaderboard — longest active daily streaks (Trending → Streaks tab). */
export default function StreakLeaderboard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/streak/leaderboard", { params: { limit: 20 } })
      .then((r) => setData(r.data))
      .catch(() => setData({ items: [], me: {} }));
  }, []);

  if (!data) return <p className="mt-6 text-cream/40 text-sm">Loading…</p>;

  return (
    <div className="mt-6" data-testid="streak-leaderboard">
      {data.me?.streak > 0 && (
        <div className="flex items-center gap-3 p-4 rounded-2xl bg-jam-gold/10 border border-jam-gold/40 mb-4" data-testid="streak-me">
          <Fire size={22} weight="fill" className="text-jam-gold" />
          <div className="flex-1">
            <p className="text-cream font-black text-sm">You're on a {data.me.streak}-day streak</p>
            <p className="text-cream/60 text-xs">
              {data.me.rank ? `Ranked #${data.me.rank} of ${data.total_active} active dancers` : "Claim daily to climb"}
              {!data.me.claimed_today && " · not claimed today yet!"}
            </p>
          </div>
        </div>
      )}

      {data.items.length === 0 ? (
        <div className="crystal-glass rounded-3xl p-6">
          <p className="text-cream font-bold">No active streaks yet.</p>
          <p className="text-cream/60 text-sm mt-1">Claim your daily <span className="text-jam-gold font-black">streak bonus</span> on the feed to start the chart.</p>
        </div>
      ) : (
        <div className="space-y-2" data-testid="streak-list">
          {data.items.map((u) => (
            <Link
              key={u.id}
              to={`/u/${u.username}`}
              data-testid={`streak-row-${u.username}`}
              className={`flex items-center gap-3 p-3.5 rounded-2xl border transition-colors ${
                u.rank <= 3 ? "bg-jam-gold/10 border-jam-gold/30 hover:border-jam-gold/60" : "bg-white/5 border-white/5 hover:border-papaya/40"
              }`}
            >
              <div className="w-8 text-center text-cream/60 font-black text-sm">{MEDALS[u.rank - 1] || `#${u.rank}`}</div>
              <div className="w-11 h-11 rounded-full overflow-hidden bg-gradient-to-br from-papaya to-sea flex items-center justify-center text-ink font-black flex-shrink-0">
                {u.avatar_path ? <img src={fileUrl(u.avatar_path)} alt="" className="w-full h-full object-cover" /> : (u.display_name || u.username)[0].toUpperCase()}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-cream font-black truncate">{u.display_name}</p>
                <p className="text-cream/50 text-xs truncate">@{u.username}{u.claimed_today && <CheckCircle size={11} weight="fill" className="inline ml-1 text-emerald-400" />}</p>
              </div>
              <div className="flex items-center gap-1 rounded-full bg-jam-gold/20 border border-jam-gold/40 px-2.5 py-1">
                <Fire size={13} weight="fill" className="text-jam-gold" />
                <span className="text-jam-gold text-xs font-black tabular-nums" data-testid={`streak-count-${u.username}`}>{u.streak}d</span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
